// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--kjsQS","text":"_103a151b99--text--VAx0v","action":"_103a151b99--action--_UeWh"};